var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-card',{attrs:{"title":_vm.$t('dashboard.waitingForApprove'),"data":_vm.data,"color":"#00E396"}},[[_c('check-square-icon',{staticClass:"custom-class",staticStyle:{"stroke":"#00E396"},attrs:{"size":"1.5x"}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }